/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {PaymentRequestComponent as Éµa} from './lib/payment-request.component';